(ns ui.components.avatar.view
  (:require
   [reagent.core :as r]
   [ui.util :as uu]))

;; the fixed tw2-class-names until we get styles.json from zapkit-components.
;; Transcribed from zapkit-components/src/components/Avatar/Avatar.styles.ts and
;; shaped like a generated zapkit-styles map, so the call sites survive the
;; switch. Upstream's `interactive` variant is left out: its only class is
;; `cursor-pointer`, which the base already carries. Interactivity still picks
;; the state, see `action-state-classes`.
(def temp-styles
  {:avatar
   {:base
    "tw2-inline-flex tw2-items-center tw2-justify-center tw2-rounded-full tw2-font-sans tw2-text-label-sm tw2-overflow-hidden tw2-flex-shrink-0 tw2-w-6 tw2-h-6 tw2-cursor-pointer tw2-transition-all tw2-duration-150 tw2-ease-in-out"
    :state
    {:default
     "tw2-bg-avatar-bg-default tw2-text-avatar-text hover:tw2-bg-avatar-bg-hover active:tw2-bg-avatar-bg-pressed"
     :hover "tw2-bg-avatar-bg-hover tw2-text-avatar-text"
     :pressed "tw2-bg-avatar-bg-pressed tw2-text-avatar-text"}}
   :image
   {:base "tw2-w-full tw2-h-full tw2-object-cover"}})

(defn action-state-classes
  "An interactive avatar renders the default state and leaves hover/pressed to
   CSS; a static one paints the requested state outright."
  [{:keys [action-state interactive? on-click]}]
  (let [styles temp-styles
        default-classes (get-in styles [:avatar :state :default])]
    (if (or interactive? (fn? on-click))
      default-classes
      (get-in styles [:avatar :state action-state] default-classes))))

(defn view
  ([]
   [view {}])
  ([props-or-child & children-content]
   (let [props (if (map? props-or-child)
                 props-or-child
                 {})
         children-content (if (map? props-or-child)
                            children-content
                            (cons props-or-child children-content))
         {:keys [storybook children src alt on-click class]
          :or   {alt "Avatar"}
          :as   props} props
         {:keys [action-state interactive?]
          :or   {action-state :default
                 interactive? true}} storybook]
     (r/with-let [image-error?* (r/atom false)]
       (let [styles temp-styles
             has-image? (and src (not @image-error?*))
             fallback-content (cond
                                (seq children-content)
                                (into [:<>] children-content)
                                children
                                children
                                :else
                                "?")
             attrs (merge
                    (-> props
                        (dissoc :storybook)
                        (assoc :class (uu/cm (get-in styles [:avatar :base])
                                             (action-state-classes {:action-state action-state
                                                                    :interactive? interactive?
                                                                    :on-click on-click})
                                             class)
                               :on-click on-click))
                    (when on-click
                      {:role      "button"
                       :tab-index 0}))]
         [:div
          attrs
          (if has-image?
            [:img
             {:src      src
              :alt      alt
              :class    (get-in styles [:image :base])
              :on-error (fn [_]
                          (reset! image-error?* true))}]
            fallback-content)])))))
